<template>
  <div class="createOrder">
    <div class="createOrder_head">
      <span v-if="yptUser.app_id == 'ypt'">{{ data.site_name }} No.{{ data.id }}</span>
      <span v-else>一路顺 {{ data.site_name }} No.{{ data.id }}</span>
      <span class="iconfont icon-xiangyou-copy"></span>
    </div>
    <div class="createOrder_content">
      <div v-if="yptUser.app_id == 'ypt'">
        <span>今日油价</span>
        <span class="warning"><span v-for="v in yptUser.priceList" style="margin-right: 0.1rem;">{{ v.oilType }} {{ v.oilPrice }}元</span></span>
      </div>
      <div>
        <span>账户油量</span>
        <span class="warning">{{ account_oil }}升</span>
      </div>
      <div>
        <span>确认油品质</span>
        <span>{{ this.oil_type }}</span>
      </div>
      <div>
                <span class="fl"><label><span>{{ couponSelected }}</span><select @change="getCouponSelected"
                                                                                 v-model="couponSelected"
                                                                                 class="select"><option
                    v-for="coupon in couponList" :value="coupon.id">{{ coupon.name }}</option></select></label></span>
        <span class="editor" v-show="couponSelected=='加油油量'">
                    <input v-model="total_number" type="number" placeholder="请输入升数">&nbsp;
                    <span>升</span>
                </span>
        <span class="editor" v-show="couponSelected=='加油金额'">
                    <input v-model="total_money" type="number" placeholder="请输入金额">&nbsp;
                    <span>元</span>
                </span>
      </div>
      <div>
        <span>车牌号</span>
        <span class="license_plate">
                    <label><span>{{ car_num }}</span><select class="select_arr_right select_car" v-model="car_num"><option
                        v-for="coupon in car_arr" :value="coupon">{{ coupon }}</option></select></label>
          <!-- <input type="text" :value="car_num"> -->
                </span>
      </div>
      <div v-if="fleet_account.is_image == 2">
        <span>加油机拍照上传</span>
        <span class="photo"><img @click="uploadPhoto" id="upload_image" style="width:20vw;height:10vh;" src="../assets/pic_upload.png"/></span>
      </div>
      <div v-if="fleet_account.is_image == 2">
        <span>加油车牌拍照上传</span>
        <span class="photo"><img @click="uploadPhoto2" id="upload_image" style="width:20vw;height:10vh;" src="../assets/pic_upload.png"/></span>
      </div>
    </div>
    <div class="selecPayType_content" v-show="selecPayType_show">
      <div class="way_">
        <span>请选择支付方式</span>
      </div>
      <div class="selected_">
        <mt-radio v-model="pay_type" :options="options"></mt-radio>
      </div>
    </div>
    <div class="bt" @click="submit">确定</div>
    <!-- 支付失败弹出框 -->
    <div v-show="failure_show" class="failure">
      <span class="X_text">X</span>
      <span>加油失败,请重新扫码</span>
      <span>
        <span>失败原因:</span>
        <span class="failure_text">{{ failure_text }}</span>
      </span>
      <span class="failure_bt" @click="checkFail">确定</span>
    </div>
    <!-- 加油点不匹配弹出框 -->
    <div v-show="noMatching_show" class="noMatching">
      <span class="X_text">X</span>
      <span>{{ noMatching_text }}</span>
      <span class="failure_bt" @click="checkFail">确认</span>
    </div>
    <!-- 车牌未绑定，弹出提示框 -->
    <div v-show="nocar_num_show" class="nocar_num">
      <span class="nocar_num_text">车牌未绑定，请联系车队做司机车牌绑定操作</span>
      <span class="nocar_num_bt" @click="nocarBt">确认</span>
    </div>
  </div>
</template>

<script>
import common from "../common";
import wx from "weixin-js-sdk";
import {Radio, Indicator} from 'mint-ui';
import Vue from "vue";
import querystring from "querystring";

Vue.component(Radio.name, Radio);
export default {
  name: 'createOrder',
  data() {
    return {
      data: {
        site_name: "",
        id: "",
        oilman_id: "",//油站id
        site_type: 0,
      },
      car_num: "",
      batch: "",//批号,扫描app二维码要用到
      total_number: "",//数量
      total_money: "",//金额
      token: "",
      car_arr: [],//存放司机车牌号的数组
      pay_type: "账户余额支付",
      oil_type: "0#",
      options: [
        {
          label: '账户余额支付',
          value: '账户余额支付',
        },
        {
          label: '微信支付',
          value: '微信支付'
        },
        {
          label: '支付宝支付',
          value: '支付宝支付'
        }
      ],
      couponList: [
        {
          id: '加油油量',
          name: "加油油量"
        },
        {
          id: "加油金额",
          name: "加油金额"
        }
      ],
      fleet_account: [],
      couponSelected: "加油油量",
      Submit_true: false,//提交了就为true,避免重复提交
      selecPayType_show: false,//选择支付方式默认不显示
      failure_text: "",
      failure_show: false,
      noMatching_text: "",
      noMatching_show: false,
      account_oil: "",//账户油量
      mobile: "",
      nocar_num_show: "",
      appXm: {
        app_id: '',
        oilNumber: '',//最大可用加油升数
        oilName: '',//油品名称
        userPhone: '',//手机号
        truckNo: '',//车牌
        accountType: '',//账号类型
        uscCode: '',//车队信用代码
      },
      yptUser: {
        app_id: '',
        oilNumber: '',//最大可用加油升数
        oilNumberB5: '',//最大可用加油升数
        truckNo: '',//车牌
        userPhone: '',//手机号
      },
      image1: '',
      image2: '',
      page_time: '',
    }
  },
  methods: {
    nocarBt() {
      this.$router.push({name: 'login'});
    },
    checkFail() {
      this.$router.push({name: 'Home'});
    },
    uploadPhoto(e) {
      wx.chooseImage({
        count: 1, // 默认9
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: r => {
          wx.getLocalImgData({
            localId: r.localIds[0].toString(),
            success: res => {
              const localData = res.localData;
              let imageBase64 = '';
              if (localData.indexOf('data:image') == 0) {
                //苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
                imageBase64 = localData;
              } else {
                //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
                //此时一个正常的base64图片路径就完美生成赋值到img的src中了
                imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
              }
              e.target.src = imageBase64;
              this.image1 = imageBase64;
            }
          });
        }
      });
    },
    uploadPhoto2(e) {
      wx.chooseImage({
        count: 1, // 默认9
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: r => {
          wx.getLocalImgData({
            localId: r.localIds[0].toString(),
            success: res => {
              const localData = res.localData;
              let imageBase64 = '';
              if (localData.indexOf('data:image') == 0) {
                //苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
                imageBase64 = localData;
              } else {
                //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
                //此时一个正常的base64图片路径就完美生成赋值到img的src中了
                imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
              }
              e.target.src = imageBase64;
              this.image2 = imageBase64;
            }
          });
        }
      });
    },
    submit() {
      if (this.Submit_true) {
        return;
      }
      Indicator.open();
      this.Submit_true = true;
      // wx.getLocation({
      //   type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      //   success: res => {
      //     let querystring = require('querystring');
      //     this.$api.post('wx/User/getLocation',
      //         querystring.stringify({
      //           latitude: res.latitude,
      //           longitude: res.longitude,
      //           token: this.token,
      //           action: "create_order",
      //         })
      //     )
      //   }
      // });
      let querystring = require('querystring');

      if (this.yptUser.app_id == 'ypt') {
        if (this.oilname == "0#" && eval(this.total_number) > eval(this.yptUser.oilNumber)) {
          this.Submit_true = false;
          common.toast("0#加油油量大于最大可用加油量");
          return;
        }
        if (this.oilname == "B5#" && eval(this.total_number) > eval(this.yptUser.oilNumberB5)) {
          this.Submit_true = false;
          common.toast("B5#加油油量大于最大可用加油量");
          return;
        }

        this.$api.post('wx/ypt/createOrder',
            querystring.stringify({
              site_id: this.data.id,
              app_id: this.yptUser.app_id,
              oilNumber: this.yptUser.oilNumber,
              oilName: "0#",
              userPhone: this.yptUser.userPhone,
              truckNo: this.yptUser.truckNo,
              userId: this.yptUser.userId,
              total_number: this.total_number,
            })
        ).then(data => {
          if (data.data.status == 1) {
            let order_id = data.data.data.id;
            this.$router.replace({path: '/orderDetail/' + order_id + '?app_id=ypt'});
          } else {
            Indicator.close();
            this.failure_show = true;
            this.failure_text = data.data.msg;
            this.Submit_true = false;
          }
        })
        return;
      }

      this.$api.post('wx/User/payOrder',
          querystring.stringify({
            site_id: this.data.id,
            car_number: this.car_num,
            oil_name: this.oil_type,
            total_number: this.total_number,
            token: this.token,
            batch: this.batch,
            page_time: this.page_time,
            latitude: this.latitude,
            longitude: this.longitude,
            image1: this.image1,
            image2: this.image2,
          })
      ).then(data => {
        if (data.data.status == 1) {
          let order_id = data.data.data.order_id;
          this.$router.replace({path: '/orderDetail/' + order_id});
        } else {
          Indicator.close();
          this.failure_show = true;
          this.failure_text = data.data.msg;
        }
      }).catch(err => {
        console.log(err);
      })
    },
    //当选择加油金额时,显示选择支付方式;
    getCouponSelected() {
      if (this.couponSelected == "加油金额") {
        this.selecPayType_show = true;
      } else {
        this.selecPayType_show = false;
      }
    },
    //验证是否为合作加油点
    VerifyDriver(site_id) {
      let token = this.token;
      let mobile = this.mobile;
      let querystring = require('querystring');
      this.$api.post('wx/checkAccount',
          querystring.stringify({
            token,
            site_id,
            mobile
          })
      ).then(data => {
        if (data.data.status == 0) {
          this.noMatching_show = true;
          this.noMatching_text = data.data.msg;
        } else {
          this.noMatching_show = false;
        }
      }).catch((err) => {
        common.toast(err);
      })
    },
    //获取账户存油和车牌号
    GetCarNumAndAccounOil(oilman_id) {
      let querystring = require('querystring');
      this.$api.post("wx/index",
          querystring.stringify({
            token: this.token,
          })
      ).then(data => {
        if (data.data.status == 1) {
          let car_Obj = data.data.data.car_list;
          let account_list = data.data.data.account_list;
          this.fleet_account = data.data.data.fleet_account;
          //获取司机车牌号(可能有多个)
          if (data.data.data.car_number) {
            this.car_num = data.data.data.car_number;
          } else {
            this.nocar_num_show = true;
          }
          for (var index in car_Obj) {
            this.car_arr.push(car_Obj[index]);
          }
          //获取该加油点账户油量
          for (let i = 0; i < account_list.length; i++) {
            if (account_list[i].oilman_id == oilman_id) {
              this.account_oil = account_list[i].oil_store;
            }
            if (this.account_oil == "" && account_list[i].oilman_id == -1) {
              this.account_oil = account_list[i].oil_store;
            }
            this.account_oil = account_list[i].oil_store;
          }
        } else {
          this.$router.replace({name: 'login'});
        }
      })
    },
    //获取司机及油站信息;
    getDate() {
      let uid = this.$router.currentRoute.params.id;
      let querystring = require('querystring');

      this.$api.post("/wx/jsConfig",
          querystring.stringify({
            url: location.href.split("#")[0]
          })
      ).then(data => {
        wx.config({
          debug: false,
          appId: data.data.data.appId,
          timestamp: data.data.data.timestamp,
          nonceStr: data.data.data.nonceStr,
          signature: data.data.data.signature,
          jsApiList: ["chooseImage", "getLocalImgData"],
          openTagList: ["wx-open-subscribe"]
        });
      }).catch(err => {
        common.toast(err);
      });

      this.VerifyDriver(uid);
      this.$api.post('/wx/site',
          querystring.stringify({
            token: this.token,
            uid: uid,
          })
      ).then(data => {
        if (!!data.data.data) {
          this.data = data.data.data;
          let oilman_id = data.data.data.oilman_id;
          this.GetCarNumAndAccounOil(oilman_id);
        }
      })
    },
    //查询用户是否绑定手机号;
    ifQueryBinding(openid) {
      let querystring = require('querystring');
      this.$api.post('/wx/checkOpenid',
          querystring.stringify({
            openid
          })
      ).then(({data}) => {
        if (data.status == 1) {
          //绑定了手机号,获取用户信息
          //双写 localStorage + cookie，记住登录状态
          common.setUserInfo({ token: data.data.token, mobile: data.data.mobile });
          this.login_bol = true;
          this.mobile = data.data.mobile;
          this.token = data.data.token;
          this.getDate();
        } else {
          //没有绑定了手机号,去登录页绑定
          this.$router.push({
            name: 'login',
            query: {
              openid: openid
            }
          })
        }
      })
    },
    //一拼通用户信息
    getYptUser(userId) {
      let uid = this.$router.currentRoute.params.id;
      let querystring = require('querystring');
      this.$api.post('/wx/ypt/user',
          querystring.stringify({
            userId: userId,
            siteId: uid
          })
      ).then(({data}) => {
        if (data.status == 1) {
          this.yptUser.userId = data.data.userId;
          this.yptUser.oilNumber = data.data.oilNumber;
          this.yptUser.oilNumberB5 = data.data.oilNumberB5;
          this.yptUser.userPhone = data.data.userPhone;
          this.yptUser.truckNo = data.data.truckNo;
          this.yptUser.app_id = data.data.app_id;
          this.yptUser.priceList = data.data.oilPriceDataList;
          this.car_num = data.data.truckNo;
          this.account_oil = data.data.oilNumber;
          this.account_oil_B5 = data.data.oilNumberB5;
        }
      })
    },
    loadData() {
      //如果有批号就获取批号
      this.batch = this.$router.currentRoute.query.batch;
      this.page_time = Math.round(new Date() / 1000);

      if (this.$router.currentRoute.query.type)
        this.oil_type = this.$router.currentRoute.query.type + "#";
      //判断地址栏上是否存在openid（兼容旧微信授权回调）
      let ifopenid = window.location.href.indexOf("openid") != -1;

      //判断是否已经登录：localStorage 优先，cookie 兜底
      let userInfo = common.getUserInfo();
      if (userInfo) {
        this.mobile = userInfo.mobile;
        this.token = userInfo.token;
        this.getDate();
      } else if (ifopenid) {
        let openid = window.location.href.split("openid=")[1].split("#/")[0];
        this.ifQueryBinding(openid);
      } else {
        //未登录：不再走微信授权，直接跳手机号验证码登录
        this.$router.replace({ name: "login" });
      }
    }
  },
  //在组件的 created 钩子中监听 $route 对象的变化
  mounted() {
    this.loadData(); // 初始化加载数据
    this.$watch('$route', () => {
      this.loadData(); // 监听路由变化，重新加载数据
    });
  },
  destroyed() {
    Indicator.close();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.createOrder {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #f6f5f5;
  color: #666666;
}

.createOrder_head {
  width: 100vw;
  height: 10vh;
  background: white;
  margin: 18px 0;
  padding: 0 30px;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  font-size: 39px;
}

.createOrder_content {
  width: 100vw;
  height: 50vh;
  background: white;
  display: -webkit-flex;
  flex-direction: column;
}

.createOrder_content > div {
  flex: 1;
  border-bottom: 1px solid #f1f1f1;
  padding: 0 30px;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  font-size: 39px;
}

.warning {
  font-size: 40px;
  color: red;
}

.editor {
  display: -webkit-flex;
}

.editor > input {
  border: none;
  width: 200px;
  text-align: right;
  color: #323333;
  font-size: 39px;
  margin: 0;
}

.editor > span {
  display: -webkit-flex;
  align-items: center;
}

.editor > input::-webkit-input-placeholder {
  font-size: 28px;
}

.license_plate {
  width: 220px;
  height: 70px;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  background: #0097fe;
  border-radius: 5px;
  color: white;
}

.license_plate > input {
  background: #0097fe;
  width: 100%;
  margin: 0;
  border: none;
  text-align: center;
  font-size: 39px;
  color: white;
}

.createOrder .bt {
  width: 600px;
  margin: 100px auto;
  height: 80px;
  padding: 0 30px;
  background: #0097fe;
  border-radius: 5px;
  line-height: 80px;
  font-size: 39px;
  color: white;
}

.selecPayType_content {
  width: 690px;
  height: 295px;
  margin-top: 20px;
  padding: 0 30px 0 30px;
  background: white;
  display: -webkit-flex;
  flex-direction: column;
}

.selecPayType_content > .way_ {
  width: 690;
  height: 95px;
  display: -webkit-flex;
  font-size: 28px;
  align-items: center;
  border-bottom: 1px solid #f1f1f1;
}

.selected_ {
  width: 690px;
  height: 200px;
}

.mint-cell-title {
  text-align: left;
  height: 60px;
  font-size: 28px;
  line-height: 60px;
}

.select {
  color: #666666;
  text-align: left;
  font-size: 30px;
  margin-left: -8px;
  position: absolute;
  left: 30px;
  opacity: 0;
}

.addClass {
  padding: 20px !important;
}

.addClass > span {
  padding-top: 0 !important;
}

.failure {
  width: 550px;
  height: 700px;
  border: 1px solid rgb(26, 184, 164);
  background: white;
  left: 100px;
  position: absolute;
  top: 200px;
  display: -webkit-flex;
  flex-direction: column;
  font-size: 40px;
  justify-content: space-between;
  padding: 0 10px;
}

.noMatching {
  width: 550px;
  height: 700px;
  border: 1px solid rgb(26, 184, 164);
  background: white;
  left: 100px;
  position: absolute;
  top: 200px;
  display: -webkit-flex;
  flex-direction: column;
  font-size: 40px;
  justify-content: center;
  padding: 0 10px;
}

.noMatching > span:nth-child(1) {
  font-size: 3rem;
  color: red;
}

.noMatching > span:nth-child(2) {
  font-size: 0.6rem;
  color: red;
}

.failure_text {
  color: red;
}

.failure > .X_text {
  font-size: 300px;
  color: red;
}

.failure_bt {
  width: 100%;
  background: #0097fe;
  height: 100px;
  line-height: 100px;
  color: white;
  margin-top: 200px;
}

.select_car {
  color: #666666;
  text-align: left;
  font-size: 30px;
  margin-left: -8px;
  position: absolute;
  opacity: 0;
}

.select_arr_right {
  left: 520px;
}

.createOrder > .nocar_num {
  width: 550px;
  height: 400px;
  border: 1px solid rgb(26, 184, 164);
  background: white;
  left: 100px;
  position: absolute;
  top: 60px;
  display: -webkit-flex;
  flex-direction: column;
  font-size: 40px;
  justify-content: center;
  padding: 0;
}

.createOrder > .nocar_num > .nocar_num_text {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.createOrder > .nocar_num > .nocar_num_bt {
  width: 100%;
  background: #0097fe;
  height: 100px;
  line-height: 100px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/creatOrder.vue